/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { OperatoreServizioMensaCompactDTO } from './operatore-servizio-mensa-compact-dto';


export interface PagedModelOperatoreServizioMensaCompactDTO { 
    content?: Array<OperatoreServizioMensaCompactDTO>;
    page?: PageMetadata;
}

